import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import '../styles/SignUpPage.css';
import '../styles/buttons.css';

import { auth } from "../config/firebase";
import {
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword
} from "firebase/auth";

import GoogleLogo from '../assets/Google_logo.png';
import { useAuth } from '../utils/authprovider';

export default function SignUpPage() {
  const [username, setUsername] = useState('');
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');

  const [usernameError, setUsernameError] = useState('');
  const [emailError, setEmailError]       = useState('');
  const [passwordError, setPasswordError] = useState('');

  const navigate = useNavigate();
  const provider = new GoogleAuthProvider();
  const { login } = useAuth();            // ← login() will re-read the cookie

  const signUpWithEmail = async () => {
    try {
      const payload = { username, email, pwd: password };
      const res = await fetch('https://api.bestday2marry.com/sign_up_user/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();

      if (data.status === 'success') {
        const userId = data.user_id;

        // Sign in to get session cookie
        const cred = await signInWithEmailAndPassword(auth, email, password);
        const idToken = await cred.user.getIdToken();
        const signInRes = await fetch(
          `https://api.bestday2marry.com/sign_in_user/?idtoken=${encodeURIComponent(idToken)}`,
          { method: 'POST', credentials: 'include' }
        );

        if (signInRes.ok) {
          login();                         // ← immediately pull the new cookie into state
          navigate(`/choose_account/${userId}`);
        } else {
          throw new Error('Failed to set session cookie');
        }
      } else {
        setEmailError('An account with this email already exists.');
      }
    } catch (err) {
      console.error(err);
      setEmailError('Sign up failed. Please try again.');
    }
  };

  // Optional: Google sign-up -> session cookie + skip straight to choose
  const handleGoogleSignUp = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const idToken = await result.user.getIdToken();
      const res = await fetch(
        `https://api.bestday2marry.com/sign_in_user/?idtoken=${encodeURIComponent(idToken)}`,
        { method: 'POST', credentials: 'include' }
      );
      const data = await res.json();

      if (data.status === 'success') {
        login();                         // ← re-sync as soon as the cookie lands
        navigate(`/choose_account/${data.user_id}`);
      } else {
        setEmailError(data.message || 'Google signup failed.');
      }
    } catch (err) {
      console.error(err);
      setEmailError('Google sign-up failed. Please try again.');
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    let valid = true;

    if (!username) {
      setUsernameError('Username is required.');
      valid = false;
    } else {
      setUsernameError('');
    }

    if (!email) {
      setEmailError('Email is required.');
      valid = false;
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      setEmailError('Invalid email address.');
      valid = false;
    } else {
      setEmailError('');
    }

    if (!password) {
      setPasswordError('Password is required.');
      valid = false;
    } else {
      setPasswordError('');
    }

    if (valid) signUpWithEmail();
  };

  useEffect(() => {
    document.body.classList.add('sign-up-body');
    return () => document.body.classList.remove('sign-up-body');
  }, []);

  return (
    <div className="sign-up-body">
      <div className="sign-in-container">
        <div className="logo"><a href="/">BestDay2Marry</a></div>
        <div className="sign-in-form">
          <h1>Sign Up</h1>
          <form onSubmit={handleSubmit} noValidate>
            <div className="form-group">
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={e => setUsername(e.target.value)}
                className={usernameError ? 'error' : ''}
              />
              {usernameError && <div className="error-message">{usernameError}</div>}
            </div>

            <div className="form-group">
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className={emailError ? 'error' : ''}
              />
              {emailError && <div className="error-message">{emailError}</div>}
            </div>

            <div className="form-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className={passwordError ? 'error' : ''}
              />
              {passwordError && <div className="error-message">{passwordError}</div>}
            </div>

            <button type="submit" className="submit-button">
              Create account
            </button>

            <div className="separator">
              <span>Or Continue With</span>
            </div>

            <button
              type="button"
              className="btn-google"
              onClick={handleGoogleSignUp}
            >
              <img src={GoogleLogo} alt="Google logo" />
              Google
            </button>

            <div className="sign-up-container">
              <p id="sign-up-msg">
                Already have an account?&nbsp;
                <a href="/signin" className="sign-up-link">Sign In</a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
